module.exports = __webpack_public_path__ + "static/media/8.323f061b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/8.png
// module id = 787
// module chunks = 0